<div class="modal-header">
  <h5 class="modal-title">{{ isEditMode ? 'แก้ไขรายชื่อประเทศตาม ISO 3166' : 'เพิ่มรายชื่อประเทศตาม ISO 3166' }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body" [class.view-only-form]="viewOnly">
  <form [formGroup]="form">
    <div class="row mb-3">
      <div class="col-sm-4"><label for="title" class="form-label mb-0 required">ชื่อประเทศ (ไทย)</label></div>
      <div class="col-sm-8"><input type="text" class="form-control form-control-sm" id="title" formControlName="title" maxlength="255"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="titleEn" class="form-label mb-0 required">ชื่อประเทศ (อังกฤษ)</label></div>
      <div class="col-sm-8"><input type="text" class="form-control form-control-sm" id="titleEn" formControlName="titleEn" maxlength="255"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="initial" class="form-label mb-0 required">อักษรย่อ</label></div>
      <div class="col-sm-8"><input type="text" class="form-control form-control-sm" id="initial" formControlName="initial" maxlength="10"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="code" class="form-label mb-0 required">รหัสประเทศ</label></div>
      <div class="col-sm-8"><input type="text" class="form-control form-control-sm" id="code" formControlName="code" maxlength="10"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="state" class="form-label mb-0">สถานะ</label></div>
      <div class="col-sm-8">
        <select class="form-select form-select-sm" id="state" formControlName="state">
          <option [ngValue]="1">เผยแพร่</option>
          <option [ngValue]="0">ไม่เผยแพร่</option>
        </select>
      </div>
    </div>

    @if (isEditMode) {
      <div class="row mb-3">
        <div class="col-sm-4"><label for="recordedBy" class="form-label mb-0">ผู้บันทึก</label></div>
        <div class="col-sm-8"><input id="recordedBy" class="form-control form-control-sm" [value]="recordedByDisplay" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="recordedAt" class="form-label mb-0">วันที่บันทึก</label></div>
        <div class="col-sm-8"><input id="recordedAt" class="form-control form-control-sm" [value]="recordedAtDisplay" readonly></div>
      </div>
    }
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-link btn-sm" (click)="activeModal.close()">ยกเลิก</button>
  @if (!viewOnly) {
    <button type="button" class="btn btn-primary btn-sm btn-custom" (click)="save()" [disabled]="isSubmitting">บันทึก</button>
  }
</div>
